import React, { useEffect, useState } from 'react';
import { CalendarClock, ShieldCheck } from 'lucide-react';
import api from '../services/api';

export default function LicenseStatus({ installed = process.env.REACT_APP_DISTRIBUTION === 'true' || window.location.port === '8765', className = 'mb-5' }) {
  const [status, setStatus] = useState(null);
  const [unavailable, setUnavailable] = useState(false);
  useEffect(() => {
    if (!installed) return undefined;
    let active = true, timer;
    const refresh = async () => {
      try {
        const { data } = await api.get('/license/status');
        if (active) { setStatus(data); setUnavailable(false); }
      } catch (_) { if (active) setUnavailable(true); }
      finally { if (active) timer = setTimeout(refresh, 60000); }
    };
    refresh();
    return () => { active = false; clearTimeout(timer); };
  }, [installed]);

  if (!installed || status?.required === false || (!status && !unavailable)) return null;
  const expiration = status?.expires_at ? new Date(status.expires_at * 1000) : null;
  const remaining = expiration ? expiration.getTime() - Date.now() : null;
  const days = remaining === null ? null : Math.max(0, Math.ceil(remaining / 86400000));
  const warning = unavailable || !status?.allowed || (days !== null && days <= 7);
  const formatted = (date) => date.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  return <section aria-label="Validade da licença" className={`${className} flex flex-wrap items-center justify-between gap-3 rounded-xl border px-4 py-3 text-sm ${warning ? 'border-amber-200 bg-amber-50 text-amber-900' : 'border-teal-200 bg-teal-50 text-teal-900'}`}>
    <div>
      <p className="flex items-center gap-2 font-semibold"><ShieldCheck size={17} />Licença{status?.name ? ` — ${status.name}` : ''}</p>
      {expiration && <p className="mt-1 flex items-center gap-2"><CalendarClock size={16} />Vencimento: {formatted(expiration)} • {remaining <= 0 ? 'Vencida' : remaining < 86400000 ? 'Vence em menos de 24 horas' : `${days} ${days === 1 ? 'dia restante' : 'dias restantes'}`}</p>}
      {status?.online === false && status?.allowed && <p className="mt-1 text-xs">Sem conexão com o servidor de licenças.{status.valid_until ? ` Autorização offline válida até ${formatted(new Date(status.valid_until * 1000))}.` : ''}</p>}
      {status?.last_validation && <p className="mt-1 text-xs">Última validação: {formatted(new Date(status.last_validation * 1000))}</p>}
      {unavailable && <p className="mt-1 text-xs">Não foi possível atualizar os dados da licença. A informação exibida é a última recebida.</p>}
      {status && !status.allowed && <p className="mt-1">{status.message}</p>}
    </div>
    <a href="/license" className="shrink-0 text-xs font-semibold underline">Verificar licença / renovação</a>
  </section>;
}
